import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "ic-snackbar",
	templateUrl: "./snackbar.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SnackbarComponent {
	@Input() text: string;
	@Input() actionText: string;

	@Output() action = new EventEmitter<void>();
	@Output() closeItem = new EventEmitter<void>();
}
